import e from "./highrise1522.mjs";
var t = e(Object.keys, Object);
export {
  t as default
};
